// extracted by mini-css-extract-plugin
export default {"wrapper":"EditPolicyGeneralForm_wrapper__hXhn4","submitWrapper":"EditPolicyGeneralForm_submitWrapper__A0rjN"};